/*
Interfaz de reservas. El numero no existe en la base.
Autor: Benjamín León
Fecha: 2024-10-21
*/

import Vehicle from './Vehicle'
export enum AdditionalTypeEnum {
  Other,
  TransferOwner,
  Tag,
}

// Transferencia de dominio
export interface TransferOwner {
  // Para transferencia
  taxType?: number
  calcCost?: number
  inscription?: number
  other?: number
}
//TODO: un hash nro, organization ?
export interface Additional {
  cost: number
  _id: string
  description: string
  date: string
  //Transferencia, TAG, otro
  type?: AdditionalTypeEnum
  transferOwner?: TransferOwner
}
export enum PaymentTypeEnum {
  Other,
  Cheque,
  VV,
  Cash,
  ETransfer,
  Credit,
}
export interface Payment {
  // El siguiente no existe en la base, pero lo usamos en la ventana de
  // Nota de venta para indicar que proviene de la reserva.
  // Se usa al grabar y/ o modificar
  reservaSw?: boolean
  value: number
  _id: string
  document: string
  date: string
  // transfer, cheque, vale vista, efectivo, otro
  type?: PaymentTypeEnum
  bank?: string
  account?: number
  // Nro del cheque o del vale vista
  number?: number
}

export interface TradeIn {
  price: number
  _id: string
  vehicle: string
}

// Le agregamos un footer por lo del las plantillas
// Y  approvedAt?: Date approvedBy?: string; requerido por Salenote
interface Reservation {
  _id: string
  price: number
  amount: number
  // aplanamos el string
  //  notes: string[];
  notes: string
  vehicle: string
  client: string
  additionals?: Additional[]
  payments?: Payment[]
  tradeIns?: TradeIn[]
  date: string
  organization: string
  profile: string
  createdAt: string
  completedAt?: string
  updatedAt?: string
  __v?: number
  voidedAt?: string // Nullable field
  voidedBy?: string // Nullable field
  voidedCause?: string // Nullable string or null
  voidedBy_user?: string
  archivedAt?: string // Nullable field
  archivedBy?: string // Nullable field
  archivedCause?: string // Nullable string or null
  archivedBy_user?: string
  number?: number
  footer?: string
  // Es una lista de vehiculos auxiliar
  tradeInVehicles?: Vehicle[]

  approvedAt?: Date
  approvedBy?: string
  profile_name?: string
  user_phone?: string
  titleConfig?: {
    type: string
    value?: string
  }
}
export default Reservation
